module.exports = __webpack_public_path__ + "media/assets/images/category/Birthday@2x-d7e1a318529d8a3610fb65994ea29a1e.png";